import React, { useContext } from "react"

const LocaleContext = React.createContext(getLocale())

export const LocaleProvider = LocaleContext.Provider

export const useLocale = (): string => useContext(LocaleContext)

function getLocale(): string {
    return (window && window["indeed.i18n.localeData"] && window["indeed.i18n.localeData"][""].Locale) || "en_US"
}
